import { ThreeSixtyViewer } from './ThreeSixtyViewer';
import * as THREE from 'three';
import * as moment from 'moment-timezone';
import Scene = THREE.Scene;

export class Utilities {
  /**
   * Converts a 3D position on the sphere to  KRpano horizontal and vertical angles.
   * @param position - The 3D position as a THREE.Vector3.
   * @returns Object containing horizontal and vertical angles.
   */
  public static ViewerPositionToKrpanoPosition(position: THREE.Vector3): {
    horizontalAngle: number;
    verticalAngle: number;
  } {
    const offsetDistance = -25;
    const radius = 500 + offsetDistance;
    const { x, y, z } = position;
    const phi = Math.acos(y / radius);
    const verticalAngle = 270 - THREE.MathUtils.radToDeg(phi);
    const theta = Math.atan2(z, x);
    const horizontalAngle = THREE.MathUtils.radToDeg(theta);
    return { horizontalAngle, verticalAngle };
  }

  /**
   * Converts KRpano horizontal and vertical angles to a 3D position on the sphere.
   * @param horizontalAngle - Horizontal angle in degrees.
   * @param verticalAngle - Vertical angle in degrees.
   * @returns 3D position as a THREE.Vector3.
   */
  public static KrpanoPositionToViewerPosition(
    horizontalAngle: number,
    verticalAngle: number,
  ): THREE.Vector3 {
    const radius = 475;
    const phi = THREE.MathUtils.degToRad(270 - verticalAngle);
    const theta = THREE.MathUtils.degToRad(horizontalAngle);
    const x = radius * Math.sin(phi) * Math.cos(theta);
    const y = radius * Math.cos(phi);
    const z = radius * Math.sin(phi) * Math.sin(theta);
    
    return new THREE.Vector3(x, y, z);
  }
  
  public static KrpanoAthAtvToViewerPosition(ath: number, atv: number): THREE.Vector3 {
    const theta = THREE.MathUtils.degToRad(ath);
    const phi = THREE.MathUtils.degToRad(90 - atv);

    const x = -500 * Math.sin(phi) * Math.cos(theta);
    const y = 500 * Math.cos(phi);
    const z = 500 * Math.sin(phi) * Math.sin(theta);

    return new THREE.Vector3(x, y, z);
  }

  public static KrpanoAthAtvToCameraTarget(
    ath: number,
    atv: number,
  ): { lat: number; lon: number; phi: number; theta: number } {
    const lat = 90 - atv;
    const lon = ath;
    const phi = THREE.MathUtils.degToRad(lat);
    const theta = THREE.MathUtils.degToRad(lon);
    return { lat, lon, phi, theta };
  }
  public static GetObservationDistanceByFOV(fov: number): number {
    return 500 / Math.tan(THREE.MathUtils.degToRad(fov / 2));
  }
  public static DisposeObject3D(scene: Scene, object: THREE.Object3D) {
    // Remove the object from the scene
    scene?.remove(object);

    // Dispose geometry if it exists
    if (object.geometry) {
      object.geometry.dispose();
    }

    // Dispose material(s)
    if (object.material) {
      // In case the material is an array (e.g., for multi-material meshes)
      if (Array.isArray(object.material)) {
        object.material.forEach((material) => material.dispose());
      } else {
        object.material.dispose();
      }
    }
  }
}
